module.exports = __webpack_public_path__ + "static/media/SparkasseIt.568ffe62.woff";